// removed by extract-text-webpack-plugin
module.exports = {"component":"_2xRmLT7WeVAv73VIXneRqn","modalContent":"_196F-RylAPBwVNJw5L2SpC","header":"_1JYID-gWT3zdP34dJO56jm","title":"_30i3YC4schlOfe83VHNecH","tail":"_1yvDom8BtuEdcaZzxQ4J5E","item":"ekOjDQRqkJRVeyFoztmZh","checkbox":"_2Eg7lwJhHEK97nZZnSeYIK","close":"_3433ngtpFc9R3CXMqrc2Be","zhuan_a":"_1TVjZrOhX8z7tOjB43yXMd","zhuan":"_3tjXRmWM8Y-mX0Caeb98Bp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CompanyInfoModal/CompanyInfoModal.scss
 ** module id = 956
 ** module chunks = 0
 **/